var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.048,
    height: 8.506,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-936.394 -276.403)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 5,
    transform: "translate(936.394 276.403)",
    fill: "#ee7d57"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(940.176 280.692)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.36,0a1.128,1.128,0,0,1,.654.2.59.59,0,0,1,.272.471V7.839a.59.59,0,0,1-.272.471,1.191,1.191,0,0,1-1.308,0,.589.589,0,0,1-.271-.471V.666A.589.589,0,0,1,44.705.2,1.129,1.129,0,0,1,45.36,0",
    transform: "translate(-37.238 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3,10.793a1.131,1.131,0,0,1,.655.2.589.589,0,0,1,.271.471v5.916a.589.589,0,0,1-.271.471,1.192,1.192,0,0,1-1.308,0l-.015-.011a.584.584,0,0,1-.258-.459V11.459a.59.59,0,0,1,.271-.47,1.126,1.126,0,0,1,.654-.2Z",
    transform: "translate(-17.917 -9.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,27.523a1.129,1.129,0,0,1,.654-.2,1.132,1.132,0,0,1,.653.2.589.589,0,0,1,.273.471v3.99a.59.59,0,0,1-.272.471,1.129,1.129,0,0,1-.654.2,1.129,1.129,0,0,1-.654-.2",
    transform: "translate(0 -24.144)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.47255d5701f8c33166d62c1de8074ab8.svg";
export { ForwardRef as ReactComponent };